/** Shared news cache normalization. */
import { sources } from "./sources.mjs";

const MAX_NEWS_AGE_MS = 3 * 24 * 60 * 60 * 1000;
const sourceById = new Map(sources.map((source) => [source.id, source]));

export function normalizeNews(items) {
  const now = Date.now();
  const cutoff = now - MAX_NEWS_AGE_MS;
  const seen = new Set();
  return (Array.isArray(items) ? items : [])
    .filter((item) => item && sourceById.has(item.source)
      && typeof item.url === "string" && item.url.length > 0
      && typeof item.title === "string" && Number.isFinite(item.publishedAt)
      && item.publishedAt >= cutoff && item.publishedAt <= now)
    .filter((item) => {
      const key = JSON.stringify([item.source, item.url]);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((item) => sourceById.get(item.source).useFeedImages === false ? { ...item, image: "" } : item)
    .sort((a, b) => b.publishedAt - a.publishedAt || (a.url < b.url ? -1 : a.url > b.url ? 1 : 0));
}
